import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {useMessages} from "../hooks/useMessages.ts";


export const IndexPage = () => {

    const {
        visibleItems,
    } = useMessages();

    return (
        <SimplePageLayout
            pageNavigation={<IndexPageNavigation/>}
            pageHeader={<IndexPageHeader/>}
        >

            <SimplePageContentWrapper>
                <RecordsTable records={visibleItems}/>
            </SimplePageContentWrapper>

        </SimplePageLayout>
    );
};
